
export enum CalendarTableSettingsView {
	CLASSIC = "CLASSIC", MODERN = "MODERN",
}